const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalicia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "550px",
    height: "160px",
    viewBox: "0 0 550 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 6.32009,153.171 c 0,-48.4843 0,-96.9332 0,-145.382 178.276,0 356.552,0 534.828,0 0,48.4489 0,96.8978 0,145.382 -178.276,0 -356.552,0 -534.828,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef945a"
    },
    d: "m 108.314,147.447 c 142.168,0 284.337,0.0508 426.556,0.10039 -0.0508,0.1004 -0.10039,0.20079 -0.15118,0.30237 -142.269,-0.10158 -284.537,-0.15118 -426.757,-0.20197 0.10039,-0.1004 0.20079,-0.15 0.35197,-0.20079 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ce4a63"
    },
    d: "m 12.5977,147.698 c 0,-0.0508 0,-0.0508 0,-0.0508 22.95,0 45.9497,0 68.9493,0.0508 -22.9996,0 -45.9993,0 -68.9493,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ce4a63"
    },
    d: "m 12.5977,14.1166 c 0,0 0,0.05079 0,0.100394 0,44.4438 0,88.937096 0,133.430996 0,0 0,0 0,0.0508 -0.100394,0 -0.151181,0 -0.200788,0 0,-44.5442 0,-89.087098 0,-133.581998 0.04961,0 0.100394,0 0.200788,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad2931"
    },
    d: "m 81.547,147.698 c -22.9996,-0.0508 -45.9993,-0.0508 -68.9493,-0.0508 0,-44.4934 0,-88.986698 0,-133.430998 22.95,-0.04961 45.9497,-0.100394 68.9493,-0.100394 2.36103,0.151181 4.77166,0.301182 7.18229,0.501969 0.200788,0.201969 3.013,0.50315 3.21378,0.703938 13.0063,2.41063 23.602,8.48623 33.5457,17.0233 4.82127,4.97245 8.6882,9.9945 12.404,15.8693 1.30512,2.7626 2.66103,5.52402 4.01693,8.28663 1.85906,6.12639 3.26457,11.6504 4.2189,17.928 0.0496,3.31418 0.15,6.67914 0.25157,10.0429 -0.30236,2.56181 -0.60354,5.12245 -0.85393,7.68426 -2.05985,10.042905 -5.6752,18.630705 -11.2488,27.167805 -2.81221,3.66615 -2.81221,3.66615 -3.013,4.11851 -7.38308,7.83308 -14.5134,13.4587 -24.0048,18.3296 -2.36103,0.85393 -4.67009,1.75748 -6.98032,2.66103 -6.076783,1.80827 -12.354303,3.013 -18.732303,3.26457 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff6600",
      fillOpacity: 1
    },
    d: "m 108.314,147.447 c 8.78741,-3.91654 16.3713,-8.9386 23.602,-15.3166 0.30118,-0.50197 2.81221,-2.86182 7.08072,-7.88387 3.91772,-5.47442 7.38308,-10.898 10.3453,-16.9736 0.85394,-2.36103 1.75748,-4.72087 2.66221,-7.03111 4.97127,-16.6217 4.71969,-32.6918 -0.50315,-49.2142 -0.85276,-2.20985 -1.7067,-4.41851 -2.56063,-6.57875 -4.92166,-9.64135 -10.7965,-17.6764 -18.5811,-25.2095 -2.00906,-1.7067 -4.01693,-3.36497 -6.02599,-5.02205 136.745,-0.04961 273.54,-0.100394 410.336,-0.100394 0.0496,0.05079 0.10039,0.100394 0.20079,0.151181 0,44.393 0,88.836703 0,133.279003 -142.219,-0.0496 -284.387,-0.1004 -426.556,-0.1004 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalicia);
export default __webpack_public_path__ + "static/media/galicia.98b70a6463306f0a5f0798a88a4e61bd.svg";
export { ForwardRef as ReactComponent };